<template>
  <div class="homepage__wrapper">
    <PortalHeader></PortalHeader>
    <main class="m-main">
      <div class="container">
        <slot>
          <div class="row">
            <div class="col-md-5">
              <div class="m-block m-block--big-height">
                <p class="m-block__title">
                  <i class="m-block__icon fa fa-newspaper-o"></i>
                  {{ $t("content.news") }}
                </p>
                <news></news>
              </div>
            </div>
            <div class="col-md-7">
              <div class="m-block m-block--big-height">
                <p class="m-block__title">
                  <i class="m-block__icon fa fa-map"></i>
                  {{ $t("content.map") }}
                </p>
                <PortalMap></PortalMap>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9">
              <div class="m-block">
                <div class="m-info">
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 text-center m-info__title">
                      <strong>{{ $t('content.parksInOperationStage') }}</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 m-info__group">
                      <span class="m-info__text--big center-block">
                        <i class="fa fa-3x font-white fa-rocket m-info__icon"></i>
                        <strong>{{ indicators.parksInOperationStage }}</strong>
                      </span>
                    </div>
                    <div class="col-xs-6 col-sm-3 text-center">
                      <p class="m-info__text--small"><strong>{{ $t('portal.revenues') }}</strong></p>
                      <p class="m-info__text center-block">
                        <strong>R$ {{ Number(indicators.revenuesEstimate).toLocaleString('pt-BR') }}</strong>
                      </p>
                    </div>
                    <div class="col-xs-6 col-sm-3 text-center">
                      <p class="m-info__text--small"><strong>{{ $t('portal.taxes') }}</strong></p>
                      <p class="m-info__text center-block">
                        <strong>R$ {{ Number(indicators.taxesEstimate).toLocaleString('pt-BR') }}</strong>
                      </p>
                    </div>
                    <div class="col-xs-6 col-sm-3 text-center">
                      <p class="m-info__text--small"><strong>{{ $t('portal.jobs') }}</strong></p>
                      <p class="m-info__text center-block">
                        <strong>{{ Number(indicators.jobsEstimate).toLocaleString('pt-BR') }}</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="m-block">
                <div class="m-info">
                  <div class="row">
                    <div class="col-xs-12 text-center m-info__title">
                      <strong>{{ $t('commons.companies') }}</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 m-info__group">
                      <span class="m-info__text--big center-block">
                        <i class="fa fa-3x font-white fa-fighter-jet m-info__icon no-padding "></i>
                        <strong>{{ indicators.companies }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9">
              <div class="m-block">
                <div class="m-info">
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 text-center m-info__title">
                      <strong>{{ $t('content.parksInImplantationStage') }}</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 m-info__group">
                      <span class="m-info__text--big center-block">
                        <i class="fa fa-3x font-white fa-cogs m-info__icon"></i>
                        <strong>{{ indicators.parksInImplantationStage }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9">
              <div class="m-block">
                <div class="m-info">
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 text-center m-info__title">
                      <strong>{{ $t('content.parksInPlanningStage') }}</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 m-info__group">
                      <span class="m-info__text--big center-block">
                        <i class="fa fa-3x font-white fa-calendar-check-o m-info__icon"></i>
                        <strong>{{ indicators.parksInPlanningStage }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slot>
      </div>
    </main>
    <PortalFooter></PortalFooter>
  </div>
</template>

<script>
import PortalHeader from './Header.vue'
import PortalFooter from './Footer.vue'
import News from './News.vue'
import PortalMap from './Map.vue'

import IndicatorsClient from '@/services/resource_client/indicators'

export default {
  name: 'Homepage',
  components: {
    News,
    PortalMap,
    PortalHeader,
    PortalFooter
  },
  data () {
    return {
      indicators: {
        parksInOperationStage: 0,
        parksInImplantationStage: 0,
        parksInPlanningStage: 0,
        companies: 0,
        revenuesEstimate: 0,
        taxesEstimate: 0,
        jobsEstimate: 0
      }
    }
  },
  mounted () {
    this.fetchIndicators()
  },
  methods: {
    fetchIndicators () {
      IndicatorsClient
        .get()
        .then((r) => {
          this.indicators = r.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Homepage.vue?dae2cc34